module.exports = __webpack_public_path__ + "static/media/Infinity-1s-200px.49463862.svg";